import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import AvatarComponent from './Avatar.component';
import { EmployeeForRender } from '../redux/Employee/Employee.type';

interface UserBadgeProps extends React.ComponentProps<'div'> {
  info?: EmployeeForRender;
}

const StyledCandidateRecordInfoRowValueAvatar = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const UserBadgeComponent = ({ info }: UserBadgeProps) => {
  const { t } = useTranslation();
  return (
    <StyledCandidateRecordInfoRowValueAvatar>
      {info ? (
        <StyledCandidateRecordInfoRowValueAvatar>
          <AvatarComponent
            src={info.avatar}
            size={14}
            gravatar={info.gravatar || false}
          />
          <div>{info.fullName}</div>
        </StyledCandidateRecordInfoRowValueAvatar>
      ) : (
        <StyledCandidateRecordInfoRowValueAvatar>
          <AvatarComponent src={'/favicon.svg'} size={14} gravatar={false} />
          <div>{t('Assistant')}</div>
        </StyledCandidateRecordInfoRowValueAvatar>
      )}
    </StyledCandidateRecordInfoRowValueAvatar>
  );
};

export default UserBadgeComponent;
